(() => {
  const element=document.getElementById('jfr-native-deals-config');
  if(!element)return;
  const config=JSON.parse(element.textContent);
  if(!['US','CA'].includes(config.country))return;
  const ownCodes=new Set(config.managedCodes.map(code=>code.toUpperCase()));
  const excluded=new Set(config.excludedProductIds);
  const root=window.Shopify.routes.root;
  let pending,lastFingerprint,lastCart;
  function offers(cart){
    const rate=cart.currency==='USD'?1:Number(window.Shopify.currency?.rate);
    const validRate=Number.isFinite(rate)&&rate>0;
    const spend=cart.items.reduce((sum,item)=>sum+(excluded.has(item.product_id)||item.gift_card||['Insurance','ship_protect','Gift Card'].includes(item.product_type)?0:item.original_line_price),0);
    return{spend,rate,validRate,net:cart.total_price,discountGoal:Math.ceil(config.percentGoalUSD*100*rate),shippingGoal:Math.ceil(config.shippingGoalUSD*100*rate),shippingMinimum:Math.ceil(config.shippingMinimumUSD*100*rate)};
  }
  function appliedCodes(cart){
    const codes=new Set((cart.discount_codes||[]).map(d=>d.code));
    const apps=[...(cart.cart_level_discount_applications||[]),...cart.items.flatMap(item=>(item.line_level_discount_allocations||[]).map(d=>d.discount_application))];
    apps.filter(d=>d.type==='discount_code').forEach(d=>codes.add(d.title));
    return[...codes];
  }
  function fingerprint(cart){return JSON.stringify({items:cart.items.map(i=>[i.key,i.quantity,i.original_line_price]),currency:cart.currency,codes:appliedCodes(cart)});}
  window.jfrRenderOfferProgress=()=>{
    if(!lastCart)return;
    const offer=offers(lastCart);
    if(!offer.validRate)return;
    const shippingReached=lastCart.requires_shipping&&offer.net>=offer.shippingMinimum;
    const reached=[offer.spend>=offer.discountGoal,shippingReached];
    const money=value=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:lastCart.currency}).format(value/100)+' '+lastCart.currency;
    document.querySelectorAll('[data-jfr-offer-card]').forEach(card=>{
      const message=card.querySelector('[data-jfr-offer-message]');
      let text;
      if(shippingReached)text=reached[0]?card.dataset.top:card.dataset.shippingAvailable;
      else if(offer.spend>=offer.shippingGoal)text=card.dataset.thresholdReached;
      else if(reached[0])text=card.dataset.unlocked+' '+card.dataset.shippingNext.replace('__AMOUNT__',money(Math.max(0,offer.shippingGoal-offer.spend)));
      else text=card.dataset.next.replace('__AMOUNT__',money(Math.max(0,offer.discountGoal-offer.spend)));
      if(message)message.textContent=text;
      const track=card.querySelector('[role="progressbar"]');
      if(track){const progress=shippingReached?100:Math.min(100,offer.spend/offer.shippingGoal*100);track.hidden=false;track.setAttribute('aria-valuenow',String(Math.round(progress)));track.querySelector('span').style.width=progress+'%';}
      card.querySelectorAll('[data-jfr-offer-tier]').forEach((tier,index)=>{tier.classList.toggle('is-reached',!!reached[index]);tier.querySelector('.jfr-tier-dot').textContent=reached[index]?'✓':String(index+1);if(lastCart.currency==='CAD')tier.querySelector('small').textContent=card.dataset.at.replace('__AMOUNT__',money(index===0?offer.discountGoal:offer.shippingGoal));});
    });
  };
  window.jfrNativeDealsSync=()=>{
    if(pending)return pending;
    pending=(async()=>{
      const response=await fetch(root+'cart.js',{headers:{Accept:'application/json'},cache:'no-store'});
      if(!response.ok)throw new Error('Unable to check cart offers');
      const cart=await response.json();lastCart=cart;
      const codes=appliedCodes(cart);
      const otherCodes=codes.filter(code=>!ownCodes.has(code.toUpperCase()));
      const previewActive=config.preview&&Date.now()<Date.parse(config.expires);
      if(!previewActive&&!codes.some(code=>ownCodes.has(code.toUpperCase())))return false;
      let desired=otherCodes;
      if(previewActive&&cart.item_count&&!otherCodes.length){desired=[...config.codes];if(config.shippingBackendReady===true&&config.shippingCode)desired.push(config.shippingCode);}
      const current=fingerprint(cart);
      if(lastFingerprint===current)return false;
      lastFingerprint=current;
      if(!cart.item_count&&!codes.some(code=>ownCodes.has(code.toUpperCase())))return false;
      const update=await fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({discount:desired.join(',')})});
      if(!update.ok){lastFingerprint=undefined;throw new Error('Unable to update cart offers');}
      lastCart=await update.json();lastFingerprint=fingerprint(lastCart);return true;
    })().finally(()=>{pending=undefined;});
    return pending;
  };
  function bind(){if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')subscribe(PUB_SUB_EVENTS.cartUpdate,()=>window.jfrNativeCartRefresh?.(false));window.jfrNativeCartRefresh?.(false);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bind,{once:true});else bind();
})();

